import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the current viewport is mobile-sized.
 * Uses the same breakpoint as the rest of the application (767px).
 *
 * @returns {boolean} True if viewport width is <= 767px, false otherwise
 *
 * @example
 * const isMobile = useIsMobile();
 * if (isMobile) {
 *   // Show mobile-specific UI
 * }
 */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};

export default useIsMobile;

